$(function(){
  $('.get-started-carousel, .our-schools-carousel, .tai-chi-carousel, .self-defense-seminars-carousel, .bday-parties-carousel').slick({
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    slideToShow: 1,
    autoplaySpeed: 5000,
    adaptiveHeight: true
  });
});  

document.addEventListener("DOMContentLoaded",
 function() {
  var div, n,
  v = document.getElementsByClassName("youtube-player");
  for (n = 0; n < v.length; n++) {
    div = document.createElement("div");
    div.setAttribute("data-id", v[n].dataset.id);
    div.innerHTML = labnolThumb(v[n].dataset.id);
    div.onclick = labnolIframe;
    v[n].appendChild(div);
  }
});

function labnolThumb(id) {
  var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
      play = '<div class="play"></div>';
  return thumb.replace("ID", id) + play;
}

function labnolIframe() {
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?autoplay=1&rel=0";
    iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    this.parentNode.replaceChild(iframe, this);
}


const container = $(".shopify-section--gallery-with-text");
const images = $(".gallery-image");
const textContainer = $(".inner-section-text");
const defaultDistance = 400; 
const centerDistance = 500; 
const minScale = 0.5; 
const maxScale = 1; 
const stickyThreshold = 1; 

$(window).on("scroll", function () {
  const scrollTop = $(window).scrollTop();
  const windowHeight = $(window).height();
  const containerTop = container.offset().top;

  const scrollProgress = Math.min(
    Math.max((scrollTop - containerTop + windowHeight) / windowHeight, 0),
    1
  );

  //console.log(scrollProgress);

  if (scrollProgress >= 2.1) {
    container.css("paddig-top", "0px");
  } else {
    container.css("padding-top", "50px");
  }
  

  if (scrollProgress >= 3) {
    container.addClass("sticky");
  } else {
    container.removeClass("sticky");
  }

  if (scrollProgress > stickyThreshold) {
    container.css("position", "relative");
  } else {
    container.css("position", "sticky");
  }

  console.log(scrollProgress);
  images.each(function(index) {
  // Default transformation when not in scroll range
  let transform = 'none';
  let opacity = 1;

  // Only calculate if scrollProgress is >= 0.4
  if (scrollProgress >= 0.4) {
    const scrollProgressx = scrollProgress;
    const position = $(this).data("position");
    
    // Calculate distance adjustment based on scroll progress
    let distanceAdjustment = 0;
    
    if (scrollProgress < 0.9) {
      // Decreasing distance (0.4 to 0.8)
      distanceAdjustment = -20 + (scrollProgress - 0.4) * 50;
    } else if (scrollProgress <= 1.7) {
      // Increasing distance (0.9 to 1.7)
      distanceAdjustment = (scrollProgress - 0.9) * 56.25; // (45 / 0.8) = 56.25 to reach +45 at 1.7
    }

    const baseDistance = position === "center" ? centerDistance : defaultDistance;
    const distance = baseDistance + distanceAdjustment;

    // Calculate position and scale
    const angle = (index * 45) * (Math.PI / 180);
    const x = Math.cos(angle) * distance * scrollProgressx;
    const y = Math.sin(angle) * distance * scrollProgressx;
    const scale = maxScale - (maxScale - minScale) * scrollProgressx;

    transform = `translate(${x}px, ${y}px) scale(${scale})`;
  }

  // Apply transformations
  $(this).css({
    transform: transform,
    opacity: opacity
  });
});

/*   images.each(function (index) {
   if (scrollProgress >= 0.4  && scrollProgress < 0.5) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance-20) : (defaultDistance-20);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
   else if (scrollProgress >= 0.5  && scrollProgress < 0.6) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance-15) : (defaultDistance-15);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
     else if (scrollProgress >= 0.6  && scrollProgress < 0.7) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance-10) : (defaultDistance-10);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
       else if (scrollProgress >= 0.7  && scrollProgress < 0.8) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance-5) : (defaultDistance-5);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
         else if (scrollProgress >= 0.8  && scrollProgress < 0.9) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance) : (defaultDistance);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
      else  if (scrollProgress >= 0.9  && scrollProgress < 1.1) {
       const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+5) : (defaultDistance+5);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
         else  if (scrollProgress >= 1.1  && scrollProgress < 1.2) {
       const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+10) : (defaultDistance+10);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
        else  if (scrollProgress >= 1.2  && scrollProgress < 1.3) {
       const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+15) : (defaultDistance+15);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     } 
           else  if (scrollProgress >= 1.3 && scrollProgress < 1.4) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+20) : (defaultDistance+20);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
         else  if (scrollProgress >= 1.4 && scrollProgress < 1.5) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+25) : (defaultDistance+25);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
             else  if (scrollProgress >= 1.5 && scrollProgress < 1.6) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+30) : (defaultDistance+30);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
                else  if (scrollProgress >= 1.6 && scrollProgress < 1.7) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+35) : (defaultDistance+35);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
                   else  if (scrollProgress >= 1.6 && scrollProgress < 1.7) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+40) : (defaultDistance+40);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
            else  if (scrollProgress >= 1.7) {
        const scrollProgressx = scrollProgress;
        const position = $(this).data("position");
        const distance = position === "center" ? (centerDistance+45) : (defaultDistance+45);
    
        const angle = (index * 45) * (Math.PI / 180); 
        const x = Math.cos(angle) * distance * scrollProgressx;
        const y = Math.sin(angle) * distance * scrollProgressx;
        const scale = maxScale - (maxScale - minScale) * scrollProgressx;
    
        $(this).css({
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          opacity: 1,
        });
     }
    else {
       $(this).css({
      transform:'none',
      opacity: 1,
    });
    }
  }); */
if (scrollProgress >= 0.8 ) {
  textContainer.css("opacity", scrollProgress);
}else{
 textContainer.css("opacity", '0');  
}
});

$(function(){
  function initializeSlick() {
      if ($(window).width() < 798) {
          $('.testimonial-slideshow').not('.slick-initialized').slick({
              infinite: true,
              arrows: false,
              autoplay: true,
              adaptiveHeight: true,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true, 
              centerPadding: '12%'
          });
      } else {
          if ($('.testimonial-slideshow').hasClass('slick-initialized')) {
              $('.testimonial-slideshow').slick('unslick');
          }
      }
  }
  initializeSlick();
  
  $(window).resize(function() {
      initializeSlick();
  });
});
 